import React, { Component } from 'react';
import moment from 'moment';

import CamdetectCamerasSettingForm from './CamdetectCamerasSettingForm';
import CamdetectCamerasPasswordForm from './CamdetectCamerasPasswordForm';

import { defaultSorter, dateSorter } from './Helpers';
import CamdetectCamerasModel from './CamdetectCamerasModel';
import CamdetectLazyImage from './CamdetectLazyImage';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, message, Card } from 'antd';
import { values } from 'lodash';

class CamdetectMessagesTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        camdetectCameraSettingsFormData: null,
        camdetectCameraPasswordFormData: null
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    expandedRowRender(record) {
        return (
            <div>
                <Row style={{ marginBottom: 20 }}>
                    {UserModel.isInRoles(['ADMIN', 'CAMDETECT_CAMERAS_IMAGE_READ']) &&
                        <Col span={24}>
                            <Card title="Poslední detekce">
                                <CamdetectLazyImage imageString={record.image} />
                            </Card>
                        </Col>
                    }
                </Row>
            </div >
        );
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Obsazeno Parking',
            dataIndex: 'occ',
            key: 'occ',
            width: 75,
            sorter: (a, b) => defaultSorter(a.occ, b.occ)
        }, {
            title: 'Obsazeno Invalidé',
            dataIndex: 'disabledOcc',
            key: 'disabledOcc',
            width: 75,
            sorter: (a, b) => dateSorter(a.disabledOcc, b.disabledOcc),
        }, {
            title: 'Čas',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 185,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
            render: (text, record) => {
                return moment(text).format('L LTS')
            }
        },
        ];

        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    onChange={this.handleChange}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    expandedRowRender={this.expandedRowRender.bind(this)}
                    style={{ border: '0px' }} />
                <CamdetectCamerasSettingForm
                    type="modal"
                    modalVisible={this.state.camdetectCameraSettingsFormData === null ? false : true}
                    initialValues={this.state.camdetectCameraSettingsFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ camdetectCameraSettingsFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        CamdetectCamerasModel.patch(this.state.camdetectCameraSettingsFormData.id, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    camdetectCameraSettingsFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
                <CamdetectCamerasPasswordForm
                    type="modal"
                    modalVisible={this.state.camdetectCameraPasswordFormData === null ? false : true}
                    initialValues={this.state.camdetectCameraPasswordFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ camdetectCameraPasswordFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        CamdetectCamerasModel.patch(this.state.camdetectCameraPasswordFormData.id, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    camdetectCameraPasswordFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
            </div>
        );
    }
}

export default CamdetectMessagesTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectMessagesTable.js